import { Stack, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { UI_SIZES } from 'app-constants'

import LostDog from './graphic/LostDog.png'
import LostDog2x from './graphic/LostDog@2x.png'
import LostDog3x from './graphic/LostDog@3x.png'

const NotFoundContainer = styled.div`
  padding-right: ${UI_SIZES.NAV.CONTAINER_WIDTH}px;
  height: calc(100vh - ${UI_SIZES.TOP_PADDING}px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export default function NotFound() {
  return (
    <NotFoundContainer>
      <Stack justifyContent="flex-end" alignItems="center" spacing={4}>
        <img src={LostDog} srcSet={`${LostDog}, ${LostDog2x} 2x, ${LostDog3x} 3x`} alt="" />
        <Stack justifyContent="flex-end" alignItems="center" spacing={1}>
          <Typography variant="h1">Oops...</Typography>
          <Typography variant="body1" color="#666666">
            Looks like Luke ate the page.
          </Typography>
        </Stack>
      </Stack>
    </NotFoundContainer>
  )
}
